import React, { memo } from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const RenderAddButton = ({
  title,
  isHeading,
  id,
  childId,
  position,
  isOption,
  addOption,
  addSubSection,
  nestedIndex,
}) => {
  console.log("rendering==>", position);
  if (isOption) {
    return (
      <Button icon={<PlusOutlined />} onClick={() => addOption(id, childId)} />
    );
  }
  return (
    <Button
      type="primary"
      onClick={() =>
        addSubSection(isHeading, id, nestedIndex !== undefined ? position : 0)
      }
    >
      {title}
    </Button>
  );
};

export default RenderAddButton;
